export const contractId = '0x4d756257Df43D5B00242461A60C94C906eedFe67'
